import { useMemo } from 'react';
import { Operation, Partner } from 'types';

type UseGetRenumerationDataForPartnerProps = {
  renumerationOperation: Operation | undefined;
  partner: Partner;
};

const extractRenumerationData = (operation: Operation, partner: Partner) => {
  const { renumerations = [] } = partner;

  const currentRenumeration = renumerations.find(
    (renumeration) => renumeration.operation === operation?._id
  );

  const rangeByClass = currentRenumeration?.rangeByClass || [];

  return {
    rangeByClass,
  };
};

export const useGetRenumerationDataForPartner = ({
  renumerationOperation,
  partner,
}: UseGetRenumerationDataForPartnerProps) => {
  const data = useMemo(() => {
    if (!renumerationOperation) {
      return {
        rangeByClass: [],
      };
    }

    return extractRenumerationData(renumerationOperation, partner);
  }, [renumerationOperation, partner]);

  return { data };
};
